<template>
  <div>
    <CCard>
      <!-- <CCardHeader><h1>{{ $t('利用規約') }}</h1></CCardHeader> -->
      <CCardHeader><h1 v-t="'利用規約'" /></CCardHeader>
      <CCardBody>
        <p v-t="'shops'" style="white-space: pre-line;" />
        <div v-if="this.$i18n.locale == 'ja'">
          <img class="sp" src="/img/terms.png" />
        </div>
        <div v-if="this.$i18n.locale == 'en'">
          <img class="sp" src="/img/terms_en.png" />
        </div>
        <!-- <ul>
          <li v-if="this.$i18n.locale == 'ja'">
            <a href="/terms/SLA.pdf" target="_blank" rel=”noopener”>{{ $t('SLA') }}</a>
          </li>
          <li v-if="this.$i18n.locale == 'en'">
            <a href="/terms/SLA_en.pdf" target="_blank" rel=”noopener”>{{ $t('SLA') }}</a>
          </li>
          <li v-if="this.$i18n.locale == 'ja'">
            <a href="/terms/Servicespec.pdf" target="_blank" rel=”noopener”>{{ $t('サービス仕様書') }}</a>
          </li>
          <li v-if="this.$i18n.locale == 'en'">
            <a href="/terms/Servicespec_en.pdf" target="_blank" rel=”noopener”>{{ $t('サービス仕様書') }}</a>
          </li>
        </ul> -->
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { messages } from '@/assets/lang/terms'

export default {
  name: 'Terms',
  i18n: {
    messages,
  },
}
</script>
<style scoped>
.sp {
  max-width: 100%;
  height: auto;
}
</style>>